import { LanguageEnumDto } from "@core/data/dto/language.dto";
import { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import { injectable } from "inversify";

@injectable()
export class LanguageIsoCodeEnumMapper {
    map(languageEnumDto: LanguageEnumDto): LanguageIsoCodeEnum {
        switch (languageEnumDto) {
            case LanguageEnumDto.English:
                return LanguageIsoCodeEnum.English;
            case LanguageEnumDto.Spanish:
                return LanguageIsoCodeEnum.Spanish;
            case LanguageEnumDto.French:
                return LanguageIsoCodeEnum.French;
            default: {
                const exhaustiveLanguage: never = languageEnumDto;
                return exhaustiveLanguage;
            }
        }
    }

    mapToDto(languageEnum: LanguageIsoCodeEnum): LanguageEnumDto {
        switch (languageEnum) {
            case LanguageIsoCodeEnum.English:
                return LanguageEnumDto.English;
            case LanguageIsoCodeEnum.Spanish:
                return LanguageEnumDto.Spanish;
            case LanguageIsoCodeEnum.French:
                return LanguageEnumDto.French;
            default: {
                const exhaustiveLanguage: never = languageEnum;
                return exhaustiveLanguage;
            }
        }
    }
}
